import React from 'react';
import Logo from './images/logo-bookmark.svg';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import "./App.css";

const Header = () => {
     return (
        <header className='header'>
            <div className='logodiv'>
               <img src={Logo} />
            </div>
            <nav className='navbar'>
               <ul>
                  <li>FEATURES</li>
                  <li>PRICING</li>
                  <li>CONTACT</li>
                  <li>
                     <button className='loginButton'>LOGIN</button>
                  </li>
               </ul>
            </nav>
            
        </header>
     );
};

export default Header;